import { render, staticRenderFns } from "./THeader.vue?vue&type=template&id=2568dbf9&scoped=true&"
import script from "./THeader.vue?vue&type=script&lang=js&"
export * from "./THeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2568dbf9",
  null
  
)

export default component.exports